import { createContext, useContext, useState, ReactNode } from 'react'

type TabType =
  | 'dashboard'
  | 'network'
  | 'cases'
  | 'orders'
  | 'alerts'
  | 'createTicket'
  | 'createOrder'
  | 'addUser'

interface TabContextType {
  activeTab: TabType
  setActiveTab: (tab: TabType) => void
}

const TabContext = createContext<TabContextType | undefined>(undefined)

export const TabProvider = ({ children }: { children: ReactNode }) => {
  const [activeTab, setActiveTab] = useState<TabType>('dashboard')

  const handleSetActiveTab = (tab: TabType) => {
    console.log('TabContext - Setting activeTab to:', tab)
    setActiveTab(tab)
  }

  return (
    <TabContext.Provider
      value={{ activeTab, setActiveTab: handleSetActiveTab }}
    >
      {children}
    </TabContext.Provider>
  )
}

export const useTab = () => {
  const context = useContext(TabContext)
  if (context === undefined) {
    throw new Error('useTab must be used within a TabProvider')
  }
  return context
}

export type { TabType }
